import ReactGA from 'react-ga';
import {Select, Row, Col} from 'antd'
import React from 'react'
import { Redirect } from 'react-router'
import moment from 'moment'
import './index.css'

const Option = Select.Option;

class Timesheets extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: '',
      selectedDate: null,
      currentTimesheet: {
        sunday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        monday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        tuesday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        wednesday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        thursday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        friday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        },
        saturday: {
          job: '',
          start: '',
          break: '',
          finish: '',
          travel: '',
          ordHours: '',
          timex5: '',
          timex2: '',
          lafha: '',
          annualLeave: '',
          personalLeave: '',
          total: ''
        }
      }
    };
  }
  componentDidMount(){
    ReactGA.pageview('/timesheets');
  }
  handleEmployeeSelect(employee) {
    this.setState({
        selectedEmployee: employee,
    }, () => {
        this.reloadTimesheetData(this.state.selectedDate);
    });
  }

  handleDateSelect(date) {
    this.setState({selectedDate: date}, () => {
      this.reloadTimesheetData(date)
    })
  }

  reloadTimesheetData(date) {
    for (var m = 0; m < this.props.timesheets.length; m++) {
      if (this.props.timesheets[m].form_values[1734] && this.props.timesheets[m].form_values["b4cf"]) {
        if (this.props.timesheets[m].form_values[1734].choice_values[0] === this.state.selectedEmployee && this.props.timesheets[m].form_values["b4cf"] === date) {
          var ent = this.props.timesheets[m].form_values;
          if (ent['cc30']) {
            if (ent['cc30'].choice_values[0]) {
              var sundayJobsite = ent['cc30'].choice_values[0];
            }
            else if (ent['cc30'].other_values[0]) {
              sundayJobsite = ent['cc30'].other_values[0]
            }
          }
          if (ent['624b']) {
            if (ent['624b'].choice_values[0]) {
              var mondayJobsite = ent['624b'].choice_values[0];
            }
            else if (ent['624b'].other_values[0]) {
              mondayJobsite = ent['624b'].other_values[0]
            }
          }
          if (ent['847c']) {
            if (ent['847c'].choice_values[0]) {
              var tuesdayJobsite = ent['847c'].choice_values[0];
            }
            else if (ent['847c'].other_values[0]) {
              tuesdayJobsite = ent['847c'].other_values[0]
            }
          }
          if (ent['ba73']) {
            if (ent['ba73'].choice_values[0]) {
              var wednesdayJobsite = ent['ba73'].choice_values[0];
            }
            else if (ent['ba73'].other_values[0]) {
              wednesdayJobsite = ent['ba73'].other_values[0]
            }
          }
          if (ent['e783']) {
            if (ent['e783'].choice_values[0]) {
              var thursdayJobsite = ent['e783'].choice_values[0];
            }
            else if (ent['e783'].other_values[0]) {
              thursdayJobsite = ent['e783'].other_values[0]
            }
          }
          if (ent['a43d']) {
            if (ent['a43d'].choice_values[0]) {
              var fridayJobsite = ent['a43d'].choice_values[0];
            }
            else if (ent['a43d'].other_values[0]) {
              fridayJobsite = ent['a43d'].other_values[0]
            }
          }
          if (ent['db2e']) {
            if (ent['db2e'].choice_values[0]) {
              var saturdayJobsite = ent['db2e'].choice_values[0];
            }
            else if (ent['db2e'].other_values[0]) {
              saturdayJobsite = ent['db2e'].other_values[0]
            }
          }
          this.setState({currentTimesheet: {
            sunday: {
              job: sundayJobsite,
              start: ent[7919],
              break: ent[8146],
              finish: ent[3989],
              travel: ent["35ce"],
              ordHours: ent["7d60"],
              timex5: ent["01ce"],
              timex2: ent["cbed"],
              lafha: ent["5df8"],
              annualLeave: ent["6dc8"],
              personalLeave: ent[5463],
              total: ent["36cc"]
            },
            monday: {
              job: mondayJobsite,
              start: ent["b982"],
              break: ent["98bb"],
              finish: ent["b272"],
              travel: ent["b833"],
              ordHours: ent["0598"],
              timex5: ent["20fb"],
              timex2: ent["3dc7"],
              lafha: ent["480a"],
              annualLeave: ent["6331"],
              personalLeave: ent[8046],
              total: ent["04b3"]
            },
            tuesday: {
              job: tuesdayJobsite,
              start: ent["d21a"],
              break: ent["c55b"],
              finish: ent["c696"],
              travel: ent["8d72"],
              ordHours: ent["c419"],
              timex5: ent["bf66"],
              timex2: ent["c71c"],
              lafha: ent["0606"],
              annualLeave: ent["cd11"],
              personalLeave: ent["7f23"],
              total: ent["b60a"]
            },
            wednesday: {
              job: wednesdayJobsite,
              start: ent["7707"],
              break: ent["0e0c"],
              finish: ent["731a"],
              travel: ent["1c53"],
              ordHours: ent["a7f0"],
              timex5: ent["3a1f"],
              timex2: ent["2a26"],
              lafha: ent["b8b5"],
              annualLeave: ent["d265"],
              personalLeave: ent["e106"],
              total: ent["b8a7"]
            },
            thursday: {
              job: thursdayJobsite,
              start: ent["9fd1"],
              break: ent["3bef"],
              finish: ent["7bcd"],
              travel: ent["99c5"],
              ordHours: ent["83da"],
              timex5: ent["25ac"],
              timex2: ent["c158"],
              lafha: ent["1b4d"],
              annualLeave: ent["96d7"],
              personalLeave: ent["d0ec"],
              total: ent["487f"]
            },
            friday: {
              job: fridayJobsite,
              start: ent["e851"],
              break: ent["53b7"],
              finish: ent["eedf"],
              travel: ent["455d"],
              ordHours: ent["bc5f"],
              timex5: ent["b5e7"],
              timex2: ent["c7fc"],
              lafha: ent["ebb5"],
              annualLeave: ent["17be"],
              personalLeave: ent["b4b1"],
              total: ent["96db"]
            },
            saturday: {
              job: saturdayJobsite,
              start: ent["bf5c"],
              break: ent["f90d"],
              finish: ent["1c83"],
              travel: ent["faa8"],
              ordHours: ent["a489"],
              timex5: ent["5d1b"],
              timex2: ent["fcb5"],
              lafha: ent["abf4"],
              annualLeave: ent["27ec"],
              personalLeave: ent["05f9"],
              total: ent["1e76"]
            }
          }
        })
        break;
      } else {
          this.setState({  currentTimesheet: {
              sunday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              monday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              tuesday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              wednesday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              thursday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              friday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              },
              saturday: {
                job: '',
                start: '',
                break: '',
                finish: '',
                travel: '',
                ordHours: '',
                timex5: '',
                timex2: '',
                lafha: '',
                annualLeave: '',
                personalLeave: '',
                total: ''
              }
            }})
        }
      }
    }
  }

  selectEmployee(nameListSorted) {
    return <Select showSearch placeholder="Select an employee"
      style={{
        width: '100%',
        paddingBottom: 10,
        paddingRight: 5
      }}
        onChange={this.handleEmployeeSelect.bind(this)}>
      {nameListSorted.map((x) => <Option key={x}>{x}</Option>)}
    </Select>
  }

  selectDate(dateList) {
    console.log(dateList);
    
    dateList.sort((a, b) => {
      a = moment(a.original, 'YYYY-MM-DD')
      b = moment(b.original, 'YYYY-MM-DD')
      if (a.isAfter(b)) {
        return -1
      } else if (a.isBefore(b)) {
        return 1
      } else {
        return 0
      }
    })
    
    return (
      <Select showSearch placeholder="Select a week-ending"
        style={{
          width: '100%',
          paddingBottom: 10,
        }}
      onChange={this.handleDateSelect.bind(this)}>
      {dateList.map((x) => <Option key={x.original}>{x.formated}</Option>)}
      </Select>
    )
  }

  render() {
    var nameList = [];
    var dateList = [];
    var dateListFormated = [];
    if (this.props.timesheets) {
      for (var i = 0; i < this.props.timesheets.length; i++) {
        if (this.props.timesheets[i].form_values[1734]) {
          nameList.push(this.props.timesheets[i].form_values[1734].choice_values[0])
          if (this.props.timesheets[i].form_values[1734].choice_values[0] === this.state.selectedEmployee) {
            dateList.push(this.props.timesheets[i].form_values.b4cf)
          }
        }
      }
      for (var q = 0; q < dateList.length; q++) {
        var str = dateList[q].split("-");
        var fYear = str[0],
            fMonth = str[1],
            fDay = str[2];
        var concatDate = fDay + "-" + fMonth + "-" + fYear;

        dateListFormated.push({
          formated: concatDate,
          original: dateList[q]
        });
      }
    }
    function sort_unique(arr) {
      return arr.sort().filter(function(el, i, a) {
        return (i === a.indexOf(el));
      });
    }

    var nameListSorted = sort_unique(nameList);
    var DateListSorted = sort_unique(dateListFormated);
    DateListSorted.reverse()

    function addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    }
    var sundayD = addDays(this.state.selectedDate, -6),
        mondayD = addDays(this.state.selectedDate, -5),
        tuesdayD = addDays(this.state.selectedDate, -4),
        wednesdayD = addDays(this.state.selectedDate, -3),
        thursdayD = addDays(this.state.selectedDate, -2),
        fridayD = addDays(this.state.selectedDate, -1),
        saturdayD = addDays(this.state.selectedDate, 0);

        sundayD = sundayD.getDate() + " / " + (sundayD.getMonth()+1);
        mondayD = mondayD.getDate() + " / " + (mondayD.getMonth()+1);
        tuesdayD = tuesdayD.getDate() + " / " + (tuesdayD.getMonth()+1);
        wednesdayD = wednesdayD.getDate() + " / " + (wednesdayD.getMonth()+1);
        thursdayD = thursdayD.getDate() + " / " + (thursdayD.getMonth()+1);
        fridayD = fridayD.getDate() + " / " + (fridayD.getMonth()+1);
        saturdayD = saturdayD.getDate() + " / " + (saturdayD.getMonth()+1);
      
      if (this.props.user.role === 'maintenance' || this.props.user.role === 'client') {
        return <Redirect to='/maintenance' />
      }
    return (
      <div>
          <h1>Timesheets</h1>
          <h4 style={{
              paddingBottom: 10
            }}>Weekly timesheets completed.</h4>
          <Row>
            <Col span={12}>
              {this.selectEmployee(nameListSorted)}
            </Col>
            <Col span={12}>
              {this.selectDate(DateListSorted)}
            </Col>
          </Row>
          <Row className='timesheetHeader'>
            <Col span={3}></Col>
            <Col span={3}>Sunday</Col>
            <Col span={3}>Monday</Col>
            <Col span={3}>Tuesday</Col>
            <Col span={3}>Wednesday</Col>
            <Col span={3}>Thursday</Col>
            <Col span={3}>Friday</Col>
            <Col span={3}>Saturday</Col>
          </Row>
          <Row className='timesheetHeader' style={{
              borderBottom: '2px solid #e8e8e8'
            }}>
            <Col span={3}></Col>
            <Col span={3}>{sundayD}</Col>
            <Col span={3}>{mondayD}</Col>
            <Col span={3}>{tuesdayD}</Col>
            <Col span={3}>{wednesdayD}</Col>
            <Col span={3}>{thursdayD}</Col>
            <Col span={3}>{fridayD}</Col>
            <Col span={3}>{saturdayD}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Job</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.sunday.job}</Col>
            {/* // TODO: make contentEditable and disable warnings */}
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.monday.job}</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.tuesday.job}</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.wednesday.job}</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.thursday.job}</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.friday.job}</Col>
            <Col span={3} contentEditable={true}>{this.state.currentTimesheet.saturday.job}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Start</Col>
            <Col span={3}>{this.state.currentTimesheet.sunday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.monday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.tuesday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.wednesday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.thursday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.friday.start}</Col>
            <Col span={3}>{this.state.currentTimesheet.saturday.start}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Break</Col>
            <Col span={3}>{this.state.currentTimesheet.sunday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.monday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.tuesday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.wednesday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.thursday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.friday.break}</Col>
            <Col span={3}>{this.state.currentTimesheet.saturday.break}</Col>
          </Row>
          <Row className='rowBoarder' style={{
              borderBottom: '2px solid #e8e8e8'
            }}>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Finish</Col>
            <Col span={3}>{this.state.currentTimesheet.sunday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.monday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.tuesday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.wednesday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.thursday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.friday.finish}</Col>
            <Col span={3}>{this.state.currentTimesheet.saturday.finish}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Travel</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.travel}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.travel}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Ord Hours</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.ordHours}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.ordHours}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Time x .5</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.timex5}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.timex5}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Time x 2</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.timex2}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.timex2}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>LAFHA</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.lafha}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.lafha}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Annual Leave</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.annualLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.annualLeave}</Col>
          </Row>
          <Row className='rowBoarder'>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Personal Leave</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.personalLeave}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.personalLeave}</Col>
          </Row>
          <Row className='' style={{
              borderTop: '2px solid #e8e8e8'
            }}>
            <Col span={3} style={{
                fontWeight: 'bold'
              }}>Total</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.sunday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.monday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.tuesday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.wednesday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.thursday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.friday.total}</Col>
            <Col contentEditable={true} span={3}>{this.state.currentTimesheet.saturday.total}</Col>
          </Row>
          <Row className='timesheetFreeInput' style={{
              borderTop: '2px solid #e8e8e8',paddingTop: '15px'
            }}>
            <Col span={3}></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
          </Row>
          <Row className='timesheetFreeInput'>
            <Col span={3}></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
          </Row>
          <Row className='timesheetFreeInput'>
            <Col span={3}></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
          </Row>
          <Row className='timesheetFreeInput'>
            <Col span={3}></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
            <Col span={3}><input type="text" style={{width: '100%'}}/></Col>
        </Row>
        </div>
    )
  }
}

export default Timesheets;
